import { render, staticRenderFns } from "./deliveryTerms.vue?vue&type=template&id=2b3a704e"
import script from "./deliveryTerms.vue?vue&type=script&lang=js"
export * from "./deliveryTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports